import React, { useState, useEffect } from "react";
import { observer } from "mobx-react";
import styled from "styled-components";
import { Layout, Space, Button, Form, Row, Col, Input, Table, Pagination, Badge, Modal, message, Tag, Tabs, Tooltip } from "antd";
import { Content, Header } from "antd/es/layout/layout";
import { ColumnsType } from "antd/lib/table";
import { ScienceEntity } from "../../entity/science-entity";
import { useStore } from "../../store";
import { getManagerPopularInfo, delPopular, offPopular } from '../../http/manager';
import Science from "./science";
import { transaction } from "mobx";
import ScienceDetail from './science-detail'
import type { TabsProps } from 'antd';
import {useNavigate} from "react-router-dom";

const ScienceList: React.FC = ()=> {
    const { scienceStore } = useStore();
    const navigateTo = useNavigate();

    useEffect(()=> {
        getList('');
        return;
    }, [])
    const getList = (key:string)=> {
        const params = {
            category: scienceStore.condition.category,
            title: scienceStore.condition.title,
            source: scienceStore.condition.source,
            creater: scienceStore.condition.creater,
            autor: scienceStore.condition.autor,
            pageNum: scienceStore.pagination.pageNum,
            pageSize: scienceStore.pagination.pageSize,
        }
        if(key !== '0' && key !== '') Object.assign(params, { state: Number(key) }) 
        getManagerPopularInfo(params)
            .then((res:any) => {
                refreshTableData((res.data && res.data.list && res.data.list.length > 0) ? res.data.list : []);
                scienceStore.pagination.total = res.data ? res.data.total : 0
            })
    }

    const refreshTableData = (data: ScienceEntity[]) => {
        const list: ScienceEntity[] = [];
        data.forEach((item) => {
            item.key = String(item.id);
            list.push(item);
        })
        transaction(() => {
            scienceStore.setDataSource(list);
        })
    }
    const toDetailModal = (record: ScienceEntity) => {
        scienceStore.setBaseLibraryDetail(record);
        scienceStore.setShowDetail(true)
    }
    const toLookComment = (record: ScienceEntity) => {
        scienceStore.setBaseLibraryDetail(record);
        navigateTo('/manager/comment', { state: { scienceDetail: JSON.stringify(record) } });
    }
    const toOffModal = (record: ScienceEntity) => {
        scienceStore.setOffRecord(record);
        scienceStore.setShowOff(true)
    }
    const toReleaseModal = (record: ScienceEntity) => {
        scienceStore.setReleaseRecord(record);
        scienceStore.setShowRelease(true)
    }
    const columns: ColumnsType<ScienceEntity> = [
        {
            title: '序号',
            width: 70,
            dataIndex: 'id',
            key: 'id',
            align: "center",
            render: (value, record, index) => {
                return <div>{index + 1}</div>
            }
        },
        {
            title: '文章分类',
            dataIndex: 'category',
            align: "center",
            key: 'category',
            render: (value)=> {
                if(value){
                    return value.split(',').map((item: string) => {
                        return <Tag key={item} color="orange">{item}</Tag>;
                    });
                }else{
                    return ''
                }
            },
        },
        {
            title: '标题',
            align: "center",
            dataIndex: 'title',
            key: 'title',
            width: '400px',
            ellipsis: {
                showTitle: false,
            },
            render: (text) => (
                <Tooltip placement="topLeft" title={text}>
                    {text}
                </Tooltip>
            ),
        },
        {
            title: '编辑人',
            align: "center",
            dataIndex: 'autor',
            key: 'autor'
        },
        {
            title: '数据来源',
            align: "center",
            dataIndex: 'source',
            key: 'source'
        },
        {
            title: '发布状态',
            align: "center",
            dataIndex: 'state',
            key: 'state',
            render:(state)=> {
                if(state == 1) {
                    return <Badge status="success" text="已发布"/>
                }else if(state == -1) {
                    return <Badge status="default" text="下线"/>
                }else if(state == -2) {
                    return <Badge status="default" text="已删除"/>
                }
            },
        },
        {
            title: '创建时间',
            align: "center",
            dataIndex: 'createtime',
            key: 'createtime'
        },
        {
            title: '操作',
            width: '360px',
            dataIndex: 'action',
            key: 'action',
            fixed: 'right',
            align: "center",
            render: (value, record) => {
                return <Space size="middle">
                    <Button onClick={() => toEditModal(record)} type={"primary"} size={'small'}>编辑</Button>
                    <Button onClick={() => toDetailModal(record)} type={"primary"} size={'small'}>详情</Button>
                    { record.state === -1 ? 
                        <Button onClick={() => toReleaseModal(record)} type={"default"} size={'small'}>发布</Button> : 
                        <Button onClick={() => toOffModal(record)} type={"default"} size={'small'}>下线</Button>
                     }
                    <Button onClick={() => toLookComment(record)} type={"primary"} size={'small'}>查看评论</Button>
                    <Button onClick={() => openDeleteConfirm(record)} type={"primary"} size={ 'small' } danger={true}>删除</Button>
                </Space>
            }
        },
    ]
    const openDeleteConfirm = (record: ScienceEntity) => {
        scienceStore.setDeleteRecord(record);
        scienceStore.showDeleteConfirm(true);
    }
    const onQuery = () => {
        getList('');
    }
    const onSizeChange = (page: any, pageSize: any) => {
        scienceStore.pagination.pageSize = pageSize;
        scienceStore.pagination.pageNum = page;
        getList('');
    }
    const onResetOnclick = () => {
        scienceStore.resetScienceCondition();
        getList('');
    }
    const setCategory = (e:any)=> {
        scienceStore.condition.category = e.target.value;
    }
    const setTitle = (e:any)=> {
        scienceStore.condition.title = e.target.value;
    }
    const setSource = (e:any)=> {
        scienceStore.condition.source = e.target.value;
    }
    const setAutor = (e:any)=> {
        scienceStore.condition.autor = e.target.value;
    }
    const setCreater = (e:any)=> {
        scienceStore.condition.creater = e.target.value;
    }
    const toEditModal = (record: ScienceEntity) => {
        scienceStore.setDetailType("edit");
        scienceStore.setBaseLibraryDetail(record);
        scienceStore.setShowEdit(true)
    }
    const openAddScienceModal = ()=> {
        scienceStore.clearDetail()
        scienceStore.setDetailType("add");
        scienceStore.setShowEdit(true);
    }
    const OnEditModalClose = () => {
        scienceStore.setShowEdit(false);
    }
    const onEditSuccess = () => {
        scienceStore.setShowEdit(false);
        getList('');
    }
    const onDeleteConfirmClose = () => {
        scienceStore.showDeleteConfirm(false);
    }
    const deleteButton = () => {
        const params = {
            id: scienceStore.deleteRecord.id,
        }
        deleteBaseLibrary(params)
    }
    const deleteBaseLibrary = (params: any) => {
        delPopular(params).then((res) => {
            if (Number(res.code) === 200) {
                message.success("删除成功");
                onDeleteConfirmClose();
                getList('');
            } else {
                if (res.message) {
                    message.error(res.message);
                } else {
                    message.error("删除失败");
                }
            }
        }).catch(() => {
            message.error("删除失败");
        })
    }
    const OnDetailModalClose = () => {
        scienceStore.setShowDetail(false);
    }
    const onOffConfirmClose = () => {
        scienceStore.setShowOff(false);
    }
    const onReleaseConfirmClose = ()=> {
        scienceStore.setShowRelease(false);
    }
    const confirmOff = (state:number)=> {
        const params = {
            id: state === 1 ? scienceStore.releaseRecord.id : scienceStore.offRecord.id,
            state: state
        }
        offPopular(params).then((res) => {
            if (Number(res.code) === 200) {
                message.success(state === 1 ? "发布成功" : "下线成功");
                onOffConfirmClose();
                onReleaseConfirmClose();
                getList('');
            } else {
                if (res.message) {
                    message.error(res.message);
                } else {
                    message.error(state === 1 ? "发布失败" : "下线失败");
                }
            }
        }).catch(() => {
            message.error(state === 1 ? "发布失败" : "下线失败");
        })
    }
    const onChange = (key: string) => {
        getList(key);
    };
    const items: TabsProps['items'] = [
        {
          key: '0',
          label: `全部`
        },
        {
          key: '1',
          label: `已发布`
        },
        {
          key: '-1',
          label: `下线`
        }
    ];
    return (
        <Layout style={{ display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
            <Header style={{background: "#ffffff", borderBottom: "1px solid #d3d3d3", padding: "0"}}>
                <TitleSpan>科普宣传</TitleSpan>
            </Header>
            <Content style={{ flex: 1, overflow: 'hidden' }}>
                <Wrapper>
                    <SearchWrapper>
                        <Space>
                            <Button 
                                type={"primary"}
                                style={{width: "100px", margin: "15px 0 15px 15px"}} 
                                size={"large"}
                                onClick={ openAddScienceModal }
                            >新建</Button>
                        </Space>
                        <Form labelAlign={"right"} wrapperCol={{span: "15"}}>
                            <Row justify={"space-between"} gutter={[15, 0]}>
                                <Col span={6}>
                                    <Form.Item labelCol={{span:"7"}} label={"分类"}>
                                        <Input placeholder={"请输入"} onChange={setCategory} value={scienceStore.condition.category}/></Form.Item>
                                </Col>
                                <Col span={6}>
                                    <Form.Item labelCol={{span:"7"}} label={"标题"}>
                                        <Input placeholder={"请输入"} onChange={setTitle} value={scienceStore.condition.title}/></Form.Item>
                                </Col>
                                <Col span={6}>
                                    <Form.Item labelCol={{span:"7"}} label={"来源"}>
                                        <Input placeholder={"请输入"} onChange={setSource} value={scienceStore.condition.source}/></Form.Item>
                                </Col>
                                <Col span={6}>
                                    <Form.Item labelCol={{span:"7"}} label={"文章作者"}>
                                        <Input placeholder={"请输入"} onChange={setAutor} value={scienceStore.condition.autor}/></Form.Item>
                                </Col>
                                <Col span={6}>
                                    <Form.Item labelCol={{span:"7"}} label={"编辑人"}>
                                        <Input placeholder={"请输入"} onChange={setCreater} value={scienceStore.condition.creater}/></Form.Item>
                                </Col>
                                <Col span={6}>
                                    <Space size={["middle", "large"]}>
                                        <Button onClick={ onQuery } type={"primary"}>查询</Button>
                                        <Button onClick={ onResetOnclick } type={"default"}>重置</Button>
                                    </Space>
                                </Col>
                            </Row>
                        </Form>
                    </SearchWrapper>
                    <ContentWrapper>
                        <Tabs defaultActiveKey="0" items={items} onChange={onChange} />
                        <Table
                            rowClassName={(type, index, intent) => {
                                return index % 2 === 0 ? "tableItemWhite" : "tableItemGray";
                            }}
                            size={"small"}
                            bordered={true}
                            dataSource={scienceStore.dataSource}
                            columns={columns}
                            pagination={{position: [], pageSize: scienceStore.pagination.pageSize}}
                        />
                        <Pagination
                            size={ "small" }
                            style={{ margin: "15px 15px 15px 0", alignSelf: "end" }}
                            total={ scienceStore.pagination.total }
                            showQuickJumper={ true }
                            showSizeChanger={ true }
                            defaultPageSize={ 10 }
                            hideOnSinglePage={ true }
                            onChange={ onSizeChange }
                            current={ scienceStore.pagination.pageNum }
                        />
                    </ContentWrapper>
                </Wrapper>
                <Modal onCancel={OnDetailModalClose}
                       width={"1200px"}
                       open={scienceStore.isShowDetail}
                       closable={true}
                       centered={true}
                       footer={null}
                       mask={true}
                       title={"科谱宣传详情"}
                       destroyOnClose={true}
                       maskClosable={true}>
                    <ScienceDetail/>
                </Modal>
                <Modal onCancel={ OnEditModalClose }
                       width={"1200px"}
                       open={scienceStore.isShowEdit}
                       closable={true}
                       centered={true}
                       footer={null}
                       mask={true}
                       destroyOnClose={true}
                       title={scienceStore.detailType === "add" ? "新建科普宣传" : "编辑科普宣传"}
                       maskClosable={true}>
                    <Science onSuccess={onEditSuccess}/>
                </Modal>
                <Modal onCancel={onDeleteConfirmClose}
                       onOk={deleteButton}
                       width={"300px"}
                       okType={"primary"}
                       okText={"确认"}
                       open={scienceStore.isShowDeleteCOnfirm}
                       closable={true}
                       title={"提示"}
                       centered={true}
                       destroyOnClose={true}
                       mask={true}
                       maskClosable={true}>
                    <div>确认删除该数据</div>
                </Modal>
                <Modal onCancel={onOffConfirmClose}
                       onOk={()=>confirmOff(-1)}
                       width={"300px"}
                       okType={"primary"}
                       okText={"确认"}
                       open={scienceStore.isShowOff}
                       closable={true}
                       title={"提示"}
                       centered={true}
                       destroyOnClose={true}
                       mask={true}
                       maskClosable={true}>
                    <div>确认下线该科普宣传</div>
                </Modal>
                <Modal onCancel={onReleaseConfirmClose}
                       onOk={()=>confirmOff(1)}
                       width={"300px"}
                       okType={"primary"}
                       okText={"确认"}
                       open={scienceStore.isShowRelease}
                       closable={true}
                       title={"提示"}
                       centered={true}
                       destroyOnClose={true}
                       mask={true}
                       maskClosable={true}>
                    <div>确认发布该科普宣传</div>
                </Modal>
            </Content>
        </Layout>
    )
}

export default observer(ScienceList);

const TitleSpan = styled.span`
  & {
    font-size: 20px;
    line-height: 16px;
    text-align: center;
    color: #333333;
    font-weight: 450;
    margin-left: 15px;
  }
`;
const Wrapper = styled.div`
  & {
    height: 100%;
    display: flex;
    flex-direction: column;
    background: #EDEFEF;
    overflow: auto;

    .tableItemWhite {
      background: white;
    }

    .tableItemGray {
      background: #F9FAFD;
    }

    .ant-table-body {
      overflow-x: scroll !important;
    }
  }
`;
const SearchWrapper = styled.div`
  & {
    margin: 15px 15px 0 15px;
    border-radius: 4px;
    border: 1px solid #EAEDF7;
    background: white;
    display: flex;
    flex-direction: column;
    padding-bottom: 10px;
    .ant-picker{
      width: 100%;
    }
  }
`;
const ContentWrapper = styled.div`
  & {
    margin: 15px;
    padding: 15px;
    border-radius: 4px;
    border: 1px solid #EAEDF7;
    background: white;
    display: flex;
    flex-direction: column;
  }
`;